import React, { useEffect, useRef, useState } from 'react';
import { IonContent, IonPage, IonDatetime, IonInput, IonList, IonItemDivider, IonItem, IonButton, IonTitle, IonToolbar, IonHeader, IonToast } from '@ionic/react';
import API from '../api';
import { RouteComponentProps, withRouter } from 'react-router';


// curl -X POST http://localhost:3000/api/add/playlist -H 'Content-Type: application/json' -d '{"name": "Test máj", "date": "2023-05-02T20:00:00+02:00", "user_id": 1, "songs_id": []}'
interface PlaylistaddProps extends RouteComponentProps {
    
}

const Playlistadd: React.FC<PlaylistaddProps> = ({location, history}) => {
    const [name, setName] = useState<string>("");
    const [date, setDate] = useState<any>();
    const [songs_id, setSongs_id] = useState<Array<number>>([]);
    const nameInputRef = useRef<HTMLIonInputElement>(null);
    const [showToastError, setShowToastError] = useState(false);
    const [toastErrorMessage, setToastErrorMessage] = useState<string>("");

    useEffect(() => {
        if(location.search) {
            const search = location.search;
            const params = new URLSearchParams(search);
            const song_id : Array<number> = [Number(params.get('songid'))];
            setSongs_id(song_id);
        }
    }, [location]);

    // Focus name input and set initial date on mount
    useEffect(() => {
        // Focus name input
        setTimeout(() => {
            nameInputRef.current?.focus();    
        }, 500);
 
        // Calculate next Sunday
        const today = new Date();
        const nextSunday = new Date(today);
        nextSunday.setDate(today.getDate() + ((7 - today.getDay()) % 7 || 7));
        nextSunday.setHours(10, 0, 0, 0); // Set time to 09:00

        setDate(nextSunday.toISOString());
    }, []);

    const addPlaylist = () => {
        if (name && date) {
            API.post("/add?type=playlist", {
                name,
                date,
                user_id: 1, 
                songs_id
              })
            .then((res: any) => {
                if (res.status === 200) {
                    history.push("/playlists?refresh=true");
                }
            })
            .catch((error: any)=>{
              
            })
        } else {
            setShowToastError(true);
            setToastErrorMessage("Zadajte názov a vyberte dátum a čas.");
        }
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>{'Pridať playlist'}</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <IonList>
                    <IonItemDivider>Názov</IonItemDivider>
                    <IonItem>
                        <IonInput ref={nameInputRef} value={name} placeholder='Zadajte názov playlistu' onIonChange={e => setName(e.detail.value!)}></IonInput>
                    </IonItem>
                    <IonItemDivider>Dátum</IonItemDivider>
                    <IonItem>
                        <IonDatetime locale="sk-SK" firstDayOfWeek={1} hourCycle="h23" value={date} onIonChange={e => setDate(e.detail.value!)}></IonDatetime>
                    </IonItem>
                    <IonButton style={{margin: "20px"}} shape='round' expand="full" onClick={addPlaylist}>Vytvoriť</IonButton>
                </IonList>
            </IonContent>
            <IonToast isOpen={showToastError} onDidDismiss={() => setShowToastError(false)} message={toastErrorMessage} duration={2000} />
        </IonPage>
    );
};

export default withRouter(Playlistadd);